// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QZrs","top":"styles_top__1NfFw","left":"styles_left__Uh2ML","description":"styles_description__3vmpp"};